<template>
    <div class="goodDetailWindow">
        <el-dialog
            title="查看图片"
            :visible.sync="dialogVisible"
            width="500px"
            >
            <span>
                <img :src="'https://api.goodyiyao.cn/'+dialog_img"  style="width: 460px;">
            </span>
        </el-dialog>
        <div class="bodyTitle">
            商品名称: <span v-text="this.$route.query.good_name"></span>
        </div>
        <div class="bodyContent">
            <div class="left">
                <div class="tab" :class="is_active===1?'is_active':''" @click="tabChange(1)">资质下载</div>
                <div class="tab" :class="is_active===2?'is_active':''" @click="tabChange(2)">批次下载</div>
            </div>
            <div class="right">
                <div class="tabContent" v-if="is_active === 1">
                    <BasicTable 
                        hiddenFooter
                        :tableData="tableData" 
                        :columns="columns" 
                        style="height:610px;"
                        >
                        <template v-slot:name="{ item }">
                        <img class="goodsImg" :src="'https://api.goodyiyao.cn/'+item.img_url" style="width: 60px;"/>
                            {{ item.name }}
                        </template>
                        <template v-slot:operate="{ item }">
                            <span class="operate" @click="toGoods(item)">查看</span>
                        </template>
                    </BasicTable>
                    <div style="padding: 8px 25px;background:#1d90d0;margin-top: 8px;color: #fff;text-decoration: none;" type="primary" class="fr mr15" @click="downLoadPackage">打包下载</div>
                </div>
                <div class="tabContent" v-if="is_active === 2">
                    <BasicTable 
                        hiddenFooter
                        :tableData="tabelData2" 
                        :columns="columns2" 
                        style="height:610px;"
                        >
                        <template v-slot:img="{ item }">
                            <img class="goodsImg" :src="spliceImg(item.img)" style="width: 60px;"/>
                        </template>
                        <template v-slot:operate="{ item }">
                            <span class="operate" @click="toGoods(item)">查看</span>
                            <!-- <a :href="'https://api.goodyiyao.cn/index.php/web/file/download?fileName='+item.fileName" style="margin-left:15px;">下载</a> -->
                        </template>
                    </BasicTable>
                    <div style="padding: 8px 25px;background:#1d90d0;margin-top: 8px;color: #fff;text-decoration: none;" type="primary" class="fr mr15" @click="downLoadPackage2">打包下载</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { GoodsService } from '../../service/goods.service';
// import fileSaver from 'file-saver';
  const columns = [
    { name: '名称', key: 'name',type: 'custom' },
    { name: '有效期', key: 'expiration_date' },
    { name: '操作', key: 'operate', type: 'custom' },
  ];
const columns2 = [
    { name: '批号', key: 'batch_no' },
    { name: '批次', key: 'batch_sn' },
    { name: '文件', key: 'img',type: 'custom' },
    { name: '有效期', key: 'expiration_date' },
    { name: '操作', key: 'operate', type: 'custom' },
  ];
  const certificate = [
    { name: '药品生产或者进口批准证明文件复印件',key: 'approval_document' },
    { name: '药品质量标准复印件',key: 'quality_standard' },
    { name: '药品说明书、包装、标签备案件复印件',key: 'instructions_packaging_labels' },
    { name: '药品样盒、说明书实样',key: 'box_instructions' },
    { name: '药品价格确认表或物价单复印件',key: 'price_confirmation' },
    { name: '药品检验报告书',key: 'inspection_report' },
    { name: '药品生产企业的营业执照复印件药品生产许可证复印件',key: 'business_production' },
    { name: '在有效期内的与品种剂型相适应的GMP认证证书复印件',key: 'gmp' },
    { name: '胶囊剂药品需提供合格的铬检验报告单复印件',key: 'chromium_inspection' },
    { name: 'OTC产品提供《非处方药药品审核登记证书》复印件',key: 'oct' },
  ]
  export default {
    data() {
      return {
        columns,
        columns2,
        certificate,
        is_active: 1,
        tableData: [],
        tabelData2: [],
        dialogVisible: false,
        dialog_img: ''
      };
    },
    watch: {
        tableData(newV) {
            this.tableData = newV
        }
    },
    methods: {
      async getList() {
          const data = await GoodsService.goodsCertificates(this.$route.query.goods_id)
          this.tabelData2 = data.batch;
          this.tableData.map((val)=>{
              this.$set(val,'img_url',data.certificates[val.key])
              let fileNameArr = data.certificates[val.key].split('/')
              let fileName = fileNameArr[fileNameArr.length-1]
              this.$set(val,'expiration_date',data.certificates['expiration_date'])
              this.$set(val,'fileName',fileName)
          });
      },
      toGoods(val) {
          this.dialogVisible = true
          this.dialog_img = val.img_url || val.img;
      },
      spliceImg(img) {
          return GoodsService.spliceImg(img);
      },
      tabChange(number) {
        this.is_active = number
      },
      async singleDownload(item) {
        const data = await GoodsService.downloadCertifcates(item.fileName);
        console.log(data);
        //   fileSaver.s
        //   saveFile()
        //   GoodsService.upload()
      },
      async downLoadPackage() {
          const data = await GoodsService.downloadCertifcatePackage(this.$route.query.goods_id);
        console.log(data);
      },
        async downLoadPackage2() {
            await GoodsService.downloadCertifcatePackage2(this.$route.query.goods_id);
        },
    },
    created() {
        this.$store.commit('hideFooter')
        this.tableData = this.certificate
        this.getList();
    }
  };
</script>

<style lang="scss" scoped>
    .bodyTitle{
        background: #ccc;
        text-indent: 1em;
        height: 24px;
        line-height: 24px;
    }
    .bodyContent{
        height: 660px;
        display: flex;
        .left{
            height: 100%;
            width: 120px;
            text-align: center;
            border-right: 1px solid #eee;
            .tab{
                height: 35px;
                line-height: 35px;
                cursor: pointer;
            }
            .tab.is_active{
                background: #ddedf6;
                height: 35px;
                position: relative;
                color: #1d90d0;
            }
            .tab.is_active::before{
                display: block;
                content: '';
                background: #2e98d5;
                height: 100%;
                width: 2px;
                position: absolute;
                left: 0;
                top: 0;
            }
        }
        .right{
            width: calc(100% - 120px);
            .tabContent{
                width: 100%;
                height: 100%;
            }
        }
    }
    .operate{
        cursor: pointer;
    }
    .operate:hover{
        color: #1d90d0;
    }
</style>

<style lang="scss">
    .goodDetailWindow{
        .el-dialog__header{
            padding-top: 8px;
            .el-dialog__title{
                font-size:14px;
            }
            .el-dialog__headerbtn{
                top: 8px;
            }
        }
        .el-dialog__body{
            padding-top: 0;
        }
    }
</style>
